var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AntModal',{attrs:{"destroyOnClose":true,"footer":null,"bodyStyle":_vm.bodyStyle},on:{"ok":_vm.closeModal},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }